import { render, staticRenderFns } from "./partner_verified_detail_religion.vue?vue&type=template&id=8a7d1d90&scoped=true"
import script from "./partner_verified_detail_religion.vue?vue&type=script&lang=js"
export * from "./partner_verified_detail_religion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7d1d90",
  null
  
)

export default component.exports